import {
  axiosGetPaginatedRequest,
  axiosGetRequest,
  axiosPatchRequest,
  axiosPostRequest,
  getIdentityRoute,
} from '../api';
import { Notification } from '../notifications';
import { ConversationPreview } from './model';
import { ChatMessageDto } from './dtos';

export const fetchChatsCall = (
  doNotRenewToken?: boolean,
  clientAction?: string
) => {
  return axiosGetRequest<ConversationPreview[]>(
    `${getIdentityRoute()}/companions/chats`,
    doNotRenewToken,
    clientAction
  );
};

export const fetchMessagesCall = (
  companionId: string,
  chatId?: string,
  xMsContinuationToken?: string,
  numrecs?: number,
  clientAction?: string
) => {
  return axiosGetPaginatedRequest<Notification[]>(
    `${getIdentityRoute()}/companion/${companionId}/chat/${chatId}/chatmessages/${
      numrecs || -1
    }`,
    xMsContinuationToken,
    undefined,
    clientAction
  );
};

export const sendMessageCall = (
  toMemberId: string,
  chatId: string | undefined,
  newChatMessage: ChatMessageDto,
  clientAction?: string
) => {
  return axiosPostRequest<ChatMessageDto, Notification[]>(
    `${getIdentityRoute()}/companion/${toMemberId}/chat/${chatId}`,
    newChatMessage,
    undefined,
    clientAction
  );
};

export const readConversationCall = (chatId: string, clientAction?: string) => {
  return axiosPatchRequest<string, void>(
    `${getIdentityRoute()}/companions/chat/${chatId}/read`,
    undefined,
    undefined,
    clientAction
  );
};

export const hideConversationCall = (chatId: string, clientAction?: string) => {
  return axiosPatchRequest<string, string>(
    `${getIdentityRoute()}/companions/chat/${chatId}/hide`,
    undefined,
    undefined,
    clientAction
  );
};
